/** Platform vs merchant custom-domain host helpers. */

export function getAppDomain() {
  const raw = (process.env.REACT_APP_APP_DOMAIN || "kataloji.com").trim().toLowerCase();
  return raw.replace(/^www\./, "").replace(/:\d+$/, "") || "kataloji.com";
}

export function normalizeHostname(host) {
  let value = String(host || "")
    .trim()
    .toLowerCase();
  value = value.replace(/^https?:\/\//, "");
  value = value.split("/")[0].split("?")[0].split("#")[0];
  if (value.includes(":") && !value.startsWith("[")) {
    value = value.split(":").slice(0, -1).join(":") || value;
  }
  if (value.startsWith("www.")) value = value.slice(4);
  return value.replace(/^\.+|\.+$/g, "");
}

export function isPlatformHost(hostname) {
  const host = String(hostname || "")
    .trim()
    .toLowerCase()
    .split(":")[0];
  if (!host || host === "localhost" || host === "127.0.0.1") return true;
  const apex = normalizeHostname(host);
  const app = getAppDomain();
  return apex === app || host === app || host === `www.${app}`;
}

export function platformOrigin() {
  const app = getAppDomain();
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return `${window.location.protocol}//${host}${window.location.port ? `:${window.location.port}` : ""}`;
    }
  }
  return `https://${app}`;
}
